export function getFullNameFromContact(contact) {
  const firstName = contact.get('first_name')
  const lastName = contact.get('last_name')
  return [firstName, lastName].join(' ').trim()
}

export function otherContactsFunction() {
  return false
}
